module.exports = __webpack_public_path__ + "static/media/screen.dbf56e07.png";